import { render } from "./StackedBarPercent.vue?vue&type=template&id=1e2d968a"
import script from "./StackedBarPercent.vue?vue&type=script&lang=js"
export * from "./StackedBarPercent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__